import { authenticatedFastApiAxiosInstance as api } from "@/lib/data/http";
import {
  fileDuplicationSchema,
  type FileDuplicationCreate,
} from "@/lib/data/schemas/file-duplication";

export const createFileDuplication = async (body: FileDuplicationCreate) =>
  fileDuplicationSchema.parse(
    (await api.post("files/duplications", body)).data,
  );

export const retrieveFileDuplication = async (
  id: string,
  cursor?: string,
  limit = 100,
) =>
  fileDuplicationSchema.parse(
    (
      await api.get(`files/duplications/${id}`, {
        params: { cursor, limit },
      })
    ).data,
  );
